import { NgModule } from '@angular/core';
import { PortfolioComponent } from './component/portfolio.component';
import { Routes, RouterModule } from '@angular/router';



const routes: Routes = [
  {
    path: '',
    title: 'portfolio',
    component: PortfolioComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class PortfolioRoutingModule { }
